module.exports = ({
    "CDMS901P001": "กรุณากรอกรหัสสถานวิจัย",
    "CDMS901P002": "กรุณากรอกชื่อสถานวิจัย",
    "CDMS901P003": "กรุณากรอกที่อยู่",
    "CDMS901P004": "กรุณากรอกจำนวนสัญญา",
    "CDMS901P005": "กรุณากรอกแผนก",
    "CDMS901MSG001": "กรุณาใส่รหัสสถานวิจัย",
    "CDMS901MSG002": "กรุณาใส่ชื่อสถานวิจัย",
    "CDMS901MSG003": "กรุณาตั้งค่าวันที่มีผลบังคับใช้ก่อนวันที่มีการลงทะเบียนเข้าร่วมวิจัยคนแรก",
    "CDMS901MSG004": "กรุณาใส่วันที่มีผลบังคับใช้",
    "CDMS901MSG005": "รหัสสถานวิจัยที่ใส่ถูกใช้ไปแล้ว",
    "CDMS901LB001": "รหัสสถานวิจัย",
    "CDMS901LB002": "ชื่อสถานวิจัย",
    "CDMS901LB003": "ที่อยู่",
    "CDMS901LB004": "ประเทศ",
    "CDMS901LB005": "Timezone",
    "CDMS901LB006": "เวอร์ชัน",
    "CDMS901LB007": "วันที่มีผลบังคับใช้",
    "CDMS901LB008": "จำนวนสัญญา",
    "CDMS901LB009": "วันที่ทำสัญญา",
    "CDMS901LB010": "แผนก",
    "CDMS901LB011": "สถานวิจัย",
    "CDMS901LB012": "การเชื่อมต่อระบบ",
    "CDMS901TT001": "การลงทะเบียนสถานวิจัย",
    "CDMS902TT001": "อัปเดตสถานวิจัย",
    "CDMS901OPT001": "eConsent"
});
